import {
  NBS_API_GET_CONFIG_REQUEST,
  NBS_API_GET_CONFIG_SUCCESS,
  NBS_API_GET_CONFIG_FAILURE
} from '../../constants/actions';
import nbsApi from '../../assets/helpers/nbsApi';
import strings from '../../assets/localization';

function nbsApiGetConfigRequest () {
  return { type: NBS_API_GET_CONFIG_REQUEST };
}
function nbsApiGetConfigSuccess (response) {
  return {
    type: NBS_API_GET_CONFIG_SUCCESS,
    response
  };
}
function nbsApiGetConfigError (error) {
  return {
    type: NBS_API_GET_CONFIG_FAILURE,
    error: error.cause || error
  };
}
export function nbsApiGetConfig (data = {}) {
  const url = 'getConfig';
  if (data.language) {
    strings.setLanguage(data.language);
  } else {
    data.language = strings.getLanguage();
  }
  return dispatch => {
    dispatch(nbsApiGetConfigRequest());
    return nbsApi(url, data)
      .then(response => dispatch(nbsApiGetConfigSuccess(response)))
      .catch(error => dispatch(nbsApiGetConfigError(error)));
  };
}
